import React, { useState, useEffect } from 'react';
import{ useRef } from 'react';
import html2canvas from 'html2canvas';
import { useParams } from 'react-router-dom';
import { Audio } from 'react-loader-spinner'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';
import Navbar from '../Components/NavBar/NavBar';
import SliderAnaylsis from '../Components/SliderAnylsis/SliderAnaylsis';
import axios from 'axios';
import ContentSeo from '../Components/ContentSeo/ContentSeo';
import HeadLines from '../Components/ContentSeo/Headlines';
import "./Content.css"
import ImageScreen from '../Components/ImageScreen/ImageScreen';
import PieChartWithCustomizedLabel from '../Components/BieAnylsis';
import { Button } from '@mui/material';
import { StatusContext } from '../Components/ContextApiStatus';
import { useContext } from 'react';
import ImagesWithAlt from '../Components/ContentSeo/ImagesWithAltProp';
import HtmlWithText from '../Components/ContentSeo/HtmlWithText';
import CompressedGZIP from '../Components/ContentSeo/CompressedGZIP';
import HaveXmlOrNot from '../Components/ContentSeo/RedirectionOrNot';
import HaveTxtFile from '../Components/ContentSeo/HavTxtRobotsFilesOrNot';
import CheckUrlsIsClear from '../Components/ContentSeo/CheckUrlsIsClean';
import CheckUrlsIsContainUnderScores from '../Components/ContentSeo/CheckUrlsIsContainUnderScoresr';
import CheckAboutEmeddedObjects from '../Components/ContentSeo/CheckAboutEmbeddedObjects';
import TallLink from '../Components/ContentResuablity/TallLink';
import HaveIconOrNot from '../Components/ContentResuablity/FavIconOrNot';
import Sidebar from '../Components/SideBar/SideBar';
import Have404Page from '../Components/ContentResuablity/Hav404Page';
import SizeOfPage from '../Components/ContentResuablity/SizeOfPage';
import TimeForDownloading from '../Components/ContentResuablity/TimeDownload';
import LangugeDetected from '../Components/ContentResuablity/LangugeDetectd';
import ShowPhone from '../Components/ContentResuablity/ShowPhone';
import DataInformationAboutIp from '../Components/ContentResuablity/DataInformationAbout';
import AnylsticsTools from '../Components/ContentResuablity/AnylsticsTools';
export default function Content(props) {
const elementToCaptureRef = useRef(null);

  const { updateStatustitle,updateStatusdescription, } = useContext(StatusContext);
  const [data, setData] = useState([]);
  const { url } = useParams();

  //setLoading Or Not 
  const [loading,setLoading] = useState(true);

//handle number of title stutus if it is true or false eor correct .....
  const [numTitleTrue,setNumTitleTrue] = useState(0)
  const [numTitleCorrect,setNumTitleCorrect] = useState(0)
  const [numTitleFalse,setNumTitleFalse] = useState(0)

//handle number of title stutus if it is true or false eor correct .....
const [numDescriptionTrue,setNumDescriptionTrue] = useState(0)
const [numDescriptionCorrect,setNumDescriptionCorrect] = useState(0)
const [numDescriptionFalse,setNumDescriptionFalse] = useState(0)

//handle number of HeadLines stutus if it is true or false eor correct .....
const [numHeadlinesTrue,setNumHeadlinesTrue] = useState(0)
const [numHeadlinesCorrect,setNumHeadlinesCorrect] = useState(0)
const [numHeadlinesFalse,setNumHeadlinesFalse] = useState(0)

//handle number of ImagesWithAlt stutus if it is true or false eor correct .....
const [numImagesTrue,setNumImagesTrue] = useState(0)
const [numImagesCorrect,setNumImagesCorrect] = useState(0)
const [numImagesFalse,setNumImagesFalse] = useState(0)

//handle number of HTMLContent stutus if it is true or false eor correct .....

const [numHtmlTrue,setNumHtmlTrue] = useState(0)
const [numHtmlCorrect,setNumHtmlCorrect] = useState(0)
const [numHtmlFalse,setNumHtmlFalse] = useState(0)

//handle number of GZIP stutus if it is true or false eor correct .....

const [numGZIPTrue,setNumGZIPTrue] = useState(0)
const [numGZIPCorrect,setNumGZIPCorrect] = useState(0)
const [numGZIPFalse,setNumGZIPFalse] = useState(0)

//have XmlOrNot 

const [xmlTrue,setXmlTrue] = useState(0)
const [xmlCorrect,setXmlCorrect] = useState(0)

//have robotFileOrNot 

const [robotTrue,setRobotTrue] = useState(0)
const [robotCorrect,setRobotCorrect] = useState(0)

//CleanUrlsOrNot 

const[cleanUrlsTrue,setCleanUrlsTrue] = useState(0)
const[cleanUrlsCorrect,setCleanUrlsCorrect] = useState(0)
const[cleanUrlsFalse,setCleanUrlsFalse] = useState(0)

//underscoreUrl 

const[underscoreUrlTrue,setUnderscoreUrlTrue] = useState(0)
const[underscoreUrlCorrect,setUnderscoreUrlCorrect] = useState(0)
const[underscoreUrlFalse,setUnderscoreUrlFalse] = useState(0)

//embedded objects 

const[embeddeObjectsTrue,setEmbeddeObjectsTrue] = useState(0)
const[embeddeObjectsCorrect,setEmbeddeObjectsCorrect] = useState(0)

//handel domainLength 

const[domainLengthTrue,setDomainLengthTrue] = useState(0)
const[domainLengthCorrect,setDomainLengthCorrect] = useState(0)

//handlle HaveIcon Status 

const [haveIconTrue,setHaveIconTrue] = useState(0)
const [haveIconCorrect,setHaveIconCorrect] = useState(0)
//handle have or not about 404 page
const[have404ErrTrue,setHave404ErrTrue] = useState(0)
const[have404ErrCorrect,setHave404ErrCorrect] = useState(0)

//handle size of page ... 

const[sizePageTrue,setSizePageTrue] = useState(0)
const[sizePageCorrect,setSizePageCorrect] = useState(0)

//handle time page 
const[timePageTrue,setTimePageTrue] = useState(0)
const[timePageCorrect,setTimePageCorrect] = useState(0)

//handle languge 

const[langugeDeclaredTrue,setLangugeDeclaredTrue] = useState(0)
const[langugeDeclaredCorrect,setLangugeDeclaredCorrect] = useState(0)

//CheckAnaylstics status 

const[checkAnaylsticsTrue,setCheckAnaylsticsTrue] = useState(0)
const[checkAnaylsticsFalse,setCheckAnaylsticsFalse] = useState(0)

const navigate = useNavigate();
const fetchData = async () => {
  try {
    setLoading(true);
    const response = await axios.get(`https://seoapi.onrender.com/scrape-website`, {
      params: { url }
    });

    const {
      title,
      description,
      headlines,
      headingAnalysis,
      totalImages,
      imagesWithAlt,
      imagesAltAnalysis,
      textContentPercentage,
      CheckForSiteMap,
      sizeSavings,
      textContentSize,
      htmlSize,
      CheckFoRobotsTxt,
      CleanUrls,
      underscoreUrl,
      containsEmbeddedObjects,
      domainLength,
      faviconUrl,
      CheckPage404,
      htmlSizeKB,
      pageLoadTimeSeconds,
      languageDeclared,
      CheckAnaylstics
    } = response.data;

    setData(response.data);

    // Update state variables incrementally
    if (response.data.websiteInfoIp) {
      setLoading(false);
    }

    const numberOfTitle = title ? title.length : 0;
    const numberOfDescription = description ? description.length : 0;

    if (headingAnalysis === 'good') {
      setNumHeadlinesTrue(numHeadlinesTrue + 1);
    } else if (headingAnalysis === 'to be improved') {
      setNumHeadlinesCorrect(numHeadlinesCorrect + 1);
    } else {
      setNumHeadlinesFalse(numHeadlinesFalse + 1);
    }

    if (textContentPercentage >= 70) {
      setNumHtmlTrue(numHtmlTrue + 1);
    } else if (textContentPercentage >= 50 && textContentPercentage < 70) {
      setNumHtmlCorrect(numHtmlCorrect + 1);
    } else {
      setNumHtmlFalse(numHtmlFalse + 1);
    }

    if (sizeSavings >= 40) {
      setNumGZIPTrue(numGZIPTrue + 1);
    } else if (sizeSavings >= 25 && sizeSavings < 40) {
      setNumGZIPCorrect(numGZIPCorrect + 1);
    } else {
      setNumGZIPFalse(numGZIPFalse + 1);
    }

    if (imagesAltAnalysis === 'good') {
      setNumImagesTrue(numImagesTrue + 1);
    } else if (imagesAltAnalysis === 'improve') {
      setNumImagesCorrect(numImagesCorrect + 1);
    } else if (imagesAltAnalysis === 'bad') {
      setNumImagesFalse(numImagesFalse + 1);
    }

    if (numberOfDescription > 100) {
      setNumDescriptionTrue(numDescriptionTrue + 1);
    } else if (numberOfDescription > 50 && numberOfDescription <= 100) {
      setNumDescriptionCorrect(numDescriptionCorrect + 1);
    } else {
      setNumDescriptionFalse(numDescriptionFalse + 1);
    }

    if (numberOfTitle > 10) {
      setNumTitleTrue(numTitleTrue + 1);
    } else if (numberOfTitle > 5 && numberOfTitle <= 10) {
      setNumTitleCorrect(numTitleCorrect + 1);
    } else {
      setNumTitleFalse(numTitleFalse + 1);
    }

    if (CheckForSiteMap === true) {
      setXmlTrue(xmlTrue + 1);
    }  else {
      setXmlCorrect(xmlCorrect + 1);
    }

    if(CheckFoRobotsTxt === true){
      setRobotTrue(robotTrue + 1)
    }else{
      setRobotCorrect(robotCorrect + 1)
    }

    if(CleanUrls >= 80){
      setCleanUrlsTrue(cleanUrlsTrue + 1)
    }else if(CleanUrls >= 50 && CleanUrls < 80){
          setCleanUrlsCorrect(cleanUrlsCorrect + 1)
    }else{
      setCleanUrlsFalse(cleanUrlsFalse + 1)
    }

    if(containsEmbeddedObjects === false){
      setEmbeddeObjectsTrue(embeddeObjectsTrue + 1)
    }else{
      setEmbeddeObjectsCorrect(embeddeObjectsCorrect + 1)
    }

    if(domainLength >= 10){
      setDomainLengthCorrect(domainLengthCorrect + 1)
    }else{
      setDomainLengthTrue(domainLengthTrue + 1)
    }

    if(faviconUrl === true){
      setHaveIconTrue(haveIconTrue + 1)
    }else{
      setHaveIconCorrect(haveIconCorrect + 1)
    }

    if(CheckPage404 === true){
      setHave404ErrTrue( have404ErrTrue + 1 )
    }else{
      setHave404ErrCorrect(have404ErrCorrect + 1)
    }

    if((htmlSizeKB / 1024) < 2){
      setSizePageTrue(sizePageTrue + 1)
    }else{
      setSizePageCorrect(sizePageCorrect + 1)
    }

    if(pageLoadTimeSeconds  < 2){
      setTimePageTrue(timePageTrue + 1)
    }else {
      setTimePageCorrect(timePageCorrect + 1)
    }

    if(languageDeclared === "لم يتم الإعلان عن لغة"){
      setLangugeDeclaredCorrect(langugeDeclaredCorrect + 1)
    }else{
      setLangugeDeclaredTrue(langugeDeclaredTrue + 1)
    }

    if(CheckAnaylstics === true){
      setCheckAnaylsticsTrue(checkAnaylsticsTrue + 1)
    }else{
      setCheckAnaylsticsFalse(checkAnaylsticsFalse + 1)
    }

    console.log(CleanUrls)
    console.log(underscoreUrl)
    console.log("cleanUrlsTrue",cleanUrlsTrue,
    "cleanUrlsCorrect",cleanUrlsCorrect,"cleanUrlsFalse",cleanUrlsFalse)

    if( underscoreUrl >= 15){
      setUnderscoreUrlFalse(underscoreUrlFalse + 1)
    }else if (data.underscoreUrl >= 6 && data.underscoreUrl < 15){
      setUnderscoreUrlCorrect(underscoreUrlCorrect + 1)
    }else{
      setUnderscoreUrlTrue(underscoreUrlTrue + 1)
    }

    updateStatustitle(
      numberOfTitle > 10 ? 'true' : numberOfTitle > 5 && numberOfTitle <= 10 ? 'correct' : 'false'
    );
    updateStatusdescription(
      numberOfDescription > 100
        ? 'true'
        : numberOfDescription > 50 && numberOfDescription <= 100
        ? 'correct'
        : 'false'
    );
  } catch (error) {
    console.error('Failed to fetch the webpage.', error);

    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text: 'عنوان URL  غير مسموح',
    });
    navigate('/');
  }
};

useEffect(() => {
  fetchData();
}, [url]);
//handle function to download content of anlysis....
const captureScreenshot = async () => {
  const elementToCapture = elementToCaptureRef.current;

  try {
    if (elementToCapture) {
      const canvas = await html2canvas(elementToCapture);
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'screenshot.png';
      link.click();
    console.log("correct onside if")

    }
    console.log("correct outside if")
  } catch (error) {
    console.error('Error capturing screenshot:', error);
  }
};

  
const StatusTrue = numTitleTrue + numDescriptionTrue + numGZIPTrue
 +numHeadlinesTrue + numImagesTrue + numHtmlTrue + timePageTrue + checkAnaylsticsTrue+
   + xmlTrue + robotTrue  + domainLengthTrue + sizePageTrue + langugeDeclaredTrue +
    underscoreUrlTrue + cleanUrlsTrue + embeddeObjectsTrue + haveIconTrue + have404ErrTrue

const StatusCorrect =numTitleCorrect + numDescriptionCorrect+numGZIPCorrect +
  numHeadlinesCorrect +numImagesCorrect+ timePageCorrect +
   have404ErrCorrect + sizePageCorrect + langugeDeclaredCorrect +
  numHtmlCorrect + underscoreUrlCorrect + embeddeObjectsCorrect
   + xmlCorrect + robotCorrect + cleanUrlsCorrect + domainLengthCorrect + haveIconCorrect

  const StatusFalse = numTitleFalse + numDescriptionFalse + numGZIPFalse + underscoreUrlFalse +
    numHeadlinesFalse + numImagesFalse + numHtmlFalse + cleanUrlsFalse +checkAnaylsticsFalse

  return (
    <div>
      {loading ?  <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Set the container height to 100% of the viewport height
  }}
>
  <div 
    style={{
      padding: "50px",
      backgroundColor: "black",
      textAlign: "center", // Center the content horizontally
      width:"90%",
      height:"90%",
      borderRadius:"20px"
    }}
  >
<div style={{
 height: "100%", width: "100%", display: "flex",
  flexDirection: "column", alignItems: "center",justifyContent:"center" }}>
  <Audio
    style={{ textAlign: "center" }}
    height="80"
    width="80"
    radius="9"
    color="green"
    ariaLabel="loading"
    wrapperStyle
    wrapperClass
  />
  <br />
  <h3 style={{ color: "white", textAlign: "center" }}>
    انتظر .. يتم تحليل موقعك الآن
  </h3>
</div>
  </div>
</div>: 
      <div ref={elementToCaptureRef}>
          <div  id={`section-${props.index}`} style={{ backgroundColor: "black", height: "200px" }}>
          <Navbar />
          <div style={{ color: "white", marginTop: "40px" }}>
            <h3>{url}</h3>
            <h4>{data.title}</h4>
          </div>
        </div>
        <div className="ContainerAnylsis" style={{ 
         float: "right", 
         marginRight: "30px",
          marginTop: "10px" }}>
          <img src="https://prothemes.biz/image/dummy-xd/720x90.png" alt="panner" style={{ maxWidth: "90%" }} />
          <div className="HeaderAnaysis">
            <div className="PieChartWithCustomizedLabel">
              <PieChartWithCustomizedLabel
                StatuesTrue={StatusTrue}
                StatusCorrect={StatusCorrect}
                StatusFalse={StatusFalse}
               index={1} />
            </div>
            <div>
              <SliderAnaylsis
               StatuesTrue={StatusTrue}
               StatusCorrect={StatusCorrect}
               StatusFalse={StatusFalse}
                className="SliderAnaylsis"
                 title={data.title} />
              <div style={{ display: "flex", marginTop: "25px",
               justifyContent: "space-between",minWidth:"300px" }}>
                <Button variant="contained" color="secondary">قارن</Button>
                <Button onClick={captureScreenshot} variant="contained" color="success">تحميل</Button>
                <Button variant="contained" color="error">تحديث</Button>
              </div>
            </div>
            <div className='ImageScreen'>
              <ImageScreen src = {'data:image/png;base64,' + data.screenShoot} />
            </div>
          </div>
        </div>
        <div className="Parent">
          <div className="child1">
        <ContentSeo index={2} title={data.title} description={data.description} />
        <ImagesWithAlt totalImages={data.totalImages}
         imagesWithAlt={data.imagesWithAlt}
         imagesAltAnalysis={data.imagesAltAnalysis}/>
           <HtmlWithText textContentPercentage={data.textContentPercentage} 
           textContentSize={data.textContentSize} htmlSize={data.htmlSize} />
           <CompressedGZIP sizeSavings={data.sizeSavings} output={data.output}/>
        <HeadLines headlines={data.headlines} headingAnalysis={data.headingAnalysis} />
        <HaveXmlOrNot CheckForSiteMap={data.CheckForSiteMap} UrlForSiteMap={data.UrlForSiteMap} />
        <HaveTxtFile UrlForRobotsTxt={data.UrlForRobotsTxt} CheckFoRobotsTxt={data.CheckFoRobotsTxt}/>
        <CheckUrlsIsClear CleanUrls={data.CleanUrls}/>
        <CheckUrlsIsContainUnderScores underscoreUrl={data.underscoreUrl}/>
        <CheckAboutEmeddedObjects containsEmbeddedObjects={data.containsEmbeddedObjects}/>
          <TallLink url={data.url} domainLength={data.domainLength}/>
          <HaveIconOrNot index={3} faviconUrl={data.faviconUrl}/>
          <Have404Page CheckPage404={data.CheckPage404} nonExistentPageUrl={data.nonExistentPageUrl}/>
          <SizeOfPage htmlSizeKB={data.htmlSizeKB}/>
          <TimeForDownloading pageLoadTimeSeconds={data.pageLoadTimeSeconds} />
          <LangugeDetected languageDeclared={data.languageDeclared}/>
          <ShowPhone index={4} src = {'data:image/png;base64,' + data.screenShootPhone}/>
          <DataInformationAboutIp websiteInfoIp={data.websiteInfoIp} websiteInfoCountry={data.websiteInfoCountry}
      websiteInfoOrganization={data.websiteInfoOrganization} />
      <AnylsticsTools CheckAnaylstics={data.CheckAnaylstics}/>
          </div>
          <div className="child2">
            <Sidebar/>
          </div>
          </div>
          </div>
      }
      </div>
    
  );
}